import React from 'react';
import { FuelSkeleton } from '@frete.com/fuel-react';

interface SkeletonRowProps {
  width?: string;
  height?: string;
}

function SkeletonRow({ width = '195px', height = '16px' }: SkeletonRowProps) {
  return (
    <div data-testid="skeleton-row">
      <FuelSkeleton
        shape="square"
        size="custom"
        width={width}
        height={height}
      />
    </div>
  );
}

export default SkeletonRow;
